// API client for the user-dashboard Worker.
// In dev the Vite proxy maps /api → http://127.0.0.1:8788.
// In prod the worker owns all of user.nanorhino.com, so /api routes hit directly.

import type { DashboardData } from './types'

const API_BASE = ''

export async function verifyDashboardPhone(
  agentId: string,
  phone: string
): Promise<{ ok: true; session: string } | { ok: false; message: string; remaining?: number }> {
  const res = await fetch(`${API_BASE}/api/dashboard/${encodeURIComponent(agentId)}/verify`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ phone }),
  })
  const json = (await res.json()) as { ok: boolean; session?: string; message?: string; remaining?: number }
  if (json.ok && json.session) {
    return { ok: true, session: json.session }
  }
  return { ok: false, message: json.message ?? 'verification failed', remaining: json.remaining }
}

export async function loadDashboard(
  agentId: string,
  session: string,
  date?: string
): Promise<DashboardData> {
  const url = date
    ? `${API_BASE}/api/dashboard/${encodeURIComponent(agentId)}?date=${encodeURIComponent(date)}`
    : `${API_BASE}/api/dashboard/${encodeURIComponent(agentId)}`
  const res = await fetch(url, {
    headers: { Authorization: `Bearer ${session}` },
  })
  if (res.status === 401) throw new Error('unauthorized')
  if (res.status === 404) throw new Error('not_found')
  if (!res.ok) {
    const text = await res.text().catch(() => '')
    throw new Error(text || `status ${res.status}`)
  }
  return (await res.json()) as DashboardData
}
